export const TOGGLE_ADD_POST = 'TOGGLE_ADD_POST';
export const ADD_POST = 'ADD_POST';
//For Auth
export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_FILTER = "SET_FILTER";
export const SET_IS_FILTER_OPENED = "SET_FILTER_OPENED";
export const SET_FILTER_RESULT_COUNT = "SET_FILTER_RESULT_COUNT";
//export const SET_EDIT_COMPANY_NAME = "SET_EDIT_COMPANY_NAME";
export const SET_EDITTING_COMPANY = "SET_EDITTING_COMPANY";
export const UPDATE_FUNDING_BY_ID = "UPDATE_FUNDING_BY_ID";
export const DELETE_FUNDING_BY_ID = "DELETE_FUNDING_BY_ID";
export const ADD_FUNDING = "ADD_FUNDING";
export const UPDATE_EMPLOYEE_BY_ID = "UPDATE_EMPLOYEE_BY_ID";
export const DELETE_EMPLOYEE_BY_ID = "DELETE_EMPLOYEE_BY_ID";
export const ADD_EMPLOYEE= "ADD_EMPLOYEE";



// WEBPACK FOOTER //
// ./client/src/actions/actiontypes.js